var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3027 12.7637L5.3756 12.7637C4.95276 12.7637 4.60999 12.4209 4.60999 11.9981C4.60999 11.5752 4.95276 11.2324 5.3756 11.2324L16.2989 11.2324L11.6273 6.49858C11.3629 6.23067 11.361 5.80063 11.623 5.5304C11.8933 5.25159 12.34 5.24962 12.6128 5.52602L19.0016 12L12.6128 18.474C12.34 18.7504 11.8933 18.7484 11.623 18.4696C11.361 18.1994 11.3629 17.7693 11.6273 17.5014L16.3027 12.7637Z",
    fill: "#393D47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.08ae0b7db84c7ca1da387aa8064f0ab6.svg";
export { ForwardRef as ReactComponent };